import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Navitem extends Component {
    render() {
        return (
            <li id={this.props.item}>
                <Link title={this.props.title} to ={this.props.tolink} className = "navelt">{this.props.item}</Link>
            </li>
        )
    }
}
export default Navitem